module.exports = __webpack_public_path__ + "static/media/santander.7b33e8a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/santander.jpg
// module id = 486
// module chunks = 0 1 2